import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {fetchInstructorCourses} from "../../../../services/operations/courseDetailsAPI";
import { getInstructorData } from '../../../../services/operations/ProfileAPI';
import { Link } from 'react-router-dom';
import InstructorChart from './InstructorChart';

function Instructor(props) {

    const [loading,setLoading] = useState(false);
    const [instructorData,setInstructorData] = useState(null);
    const [courses,setCourses] = useState([]);
    const {token} = useSelector((state)=>state.auth);
    const {user} = useSelector((state)=>state.profile);

    useEffect(()=>{
        async function getCourseDataWithStats()
        {
            setLoading(true);
            const instructorApiData = await getInstructorData(token);
            const result = await fetchInstructorCourses(token);

            // console.log("Instructor api: ",instructorApiData);
            // console.log("Instructor Courses: ",result);

            if(instructorApiData.length)
            {
                setInstructorData(instructorApiData);
            }

            if(result)
            {
                setCourses(result);
            }

            setLoading(false);
        }

        getCourseDataWithStats();
    },[])

    const totalAmount = instructorData?.reduce((acc,curr)=> acc + curr.totalAmountGenerated,0);
    const totalStudents = instructorData?.reduce((acc,curr)=> acc + curr.totalStudentsEnrolled,0)

    return (
        <div className='text-white'>
            <div>
                <p className='text-2xl text-richblack-25 font-semibold'>Hi {user?.firstName} 👋</p>
                <p className='text-richblack-100'>Let's start something new</p>
            </div>
            {loading ? (<div className='flex w-full h-screen justify-center items-center'>
                <div className='spinner'></div>
            </div>):(
                courses.length > 0 ? (
                    <div className='mt-5'>
                        <div className='flex max-[450px]:flex-col gap-x-5 w-full items-center justify-center'>
                            <div className='w-[90%]'>
                                <InstructorChart courses={instructorData}/>
                            </div>
                            <div className='bg-richblack-800 h-[37.2rem] flex flex-col gap-8 rounded-md p-8 w-[40%] max-[450px]:w-[90%] max-[450px]:mt-5'>
                                <p className='text-3xl font-semibold'>Statistics</p>
                                <div className='flex flex-col gap-1'>
                                    <p className='text-richblack-100 font-semibold'>Total Courses</p>
                                    <p className='text-richblack-5 text-2xl'>{courses.length}</p>
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <p className='text-richblack-100 font-semibold'>Total Students</p>
                                    <p className='text-richblack-5 text-2xl'>{totalStudents}</p>
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <p className='text-richblack-100 font-semibold'>Total Income</p>
                                    <p className='text-richblack-5 text-2xl'>Rs. {totalAmount}</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div className='bg-richblack-800 max-[450px]:w-[90%] max-[450px]:translate-x-5 max-[450px]:flex-col max-[450px]:justify-center max-[450px]:items-center mt-10 rounded-md'>
                            {/* Course card */}
                            <div className='flex justify-between p-8'>
                                <p className='text-2xl font-semibold'>Your Courses</p>
                                <Link to={`/dashboard/my-courses`}>
                                    <p className='text-yellow-25'>View all</p>
                                </Link>
                            </div>
                            <div className='flex max-[450px]:flex-col max-[450px]:gap-5 justify-between p-5'>
                                {
                                    courses.slice(0,3).map((course,index)=>{
                                        return (
                                            <div key={index}>
                                                <img className='w-[270px] rounded-md' src={course.thumbnail} alt="" />
                                                <div className='mt-5'>
                                                    <p className='text-richblack-50'>{course.courseName}</p>
                                                    <div className='flex gap-x-2 text-richblack-100'>
                                                        <p>{course.studentEnrolled.length} Students</p>
                                                        <span>|</span>
                                                        <p>Rs. {course.price}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                ) : (<div>
                    <p>Your have not created any course yet</p>
                    <Link to={`/dashboard/add-course`}>Create a course</Link>
                </div>)
            )}
        </div>
    );
}

export default Instructor;